/**
 * Comprueba el acceso a una ruta.
 *
 * Devuelve true si se permite el acceso y false en caso contrario
 *
 * @param authInfo informacion del usuario actual
 * @param security seguridad de la ruta
 * @param callbacks callbacks que se llaman para realizar acciones custom en cada caso (opcional).
 */
export function checkAccess(authInfo, security, callbacks = {}) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    // Si no requiere auth, se permite el acceso
    if (!security) {
        (_b = (_a = callbacks).onGranted) === null || _b === void 0 ? void 0 : _b.call(_a);
        return true;
    }
    if (!authInfo.authenticated) {
        // Si require auth y el usuario no esta logueado, no se permite el acceso
        (_d = (_c = callbacks).onLoginRequired) === null || _d === void 0 ? void 0 : _d.call(_c);
        return false;
    }
    if (Array.isArray(security)) {
        // Si la seguridad de la ruta es la lista de roles, el usuario debe tener al menos uno para acceder
        if (authInfo.roles.some(r => security.includes(r))) {
            (_f = (_e = callbacks).onGranted) === null || _f === void 0 ? void 0 : _f.call(_e);
            return true;
        }
        else {
            // Si no tiene ningun rol de los requeridos, no se permite el acceso
            (_h = (_g = callbacks).onRoleRequired) === null || _h === void 0 ? void 0 : _h.call(_g, security);
            return false;
        }
    }
    else {
        // Si la seguridad de la ruta no es una lista de roles, simplemente alcanza con que este autenticado
        (_k = (_j = callbacks).onGranted) === null || _k === void 0 ? void 0 : _k.call(_j);
        return true;
    }
}
//# sourceMappingURL=RouteSecurity.js.map